// extracted by mini-css-extract-plugin
export default {"plan":"MailboxPlanRows-plan_RTP4E"};